import('./bootstrap')
	.catch(_err => {
		//Need to write logic
	});
